import { ACTIVITIES_FOR_EMPLOYEE } from '@src/graphql/queries/activity';
import { useActivityFilter } from '@src/hooks/useActivityFilter';
import { pick } from 'lodash';
import { useMemo } from 'react';
import { usePaginatedFetchItems } from '../../../../pe-core-frontend/src/lib';
export const useActivitiesForEmployee = ({ clientId, employeeId, }) => {
    const { filter, setFilter: _setFilter, hasFilter, statuses, } = useActivityFilter({
        key: `emp-${employeeId}`,
    });
    const spec = useMemo(() => {
        return {
            clientId,
            employeeId,
            ...pick(filter, 'dateRange', 'type', 'searchText'),
            statuses,
        };
    }, [clientId, employeeId, filter, statuses]);
    const { items: activities, error, loading, page, setPage, pageSize, setPageSize, total, } = usePaginatedFetchItems({
        fetchQuery: ACTIVITIES_FOR_EMPLOYEE,
        dataProp: 'activitiesForEmployee',
        spec,
        initialPageSize: 10,
    });
    const setFilter = (value) => {
        _setFilter(value);
        setPage(1);
    };
    return {
        activities,
        error,
        loading,
        filter,
        setFilter,
        hasFilter,
        page,
        setPage,
        pageSize,
        setPageSize,
        total,
    };
};
